module.exports = __webpack_public_path__ + "static/media/loading.447c9bc3.gif";